import { render, staticRenderFns } from "./DataScanStandmansFromTime.vue?vue&type=template&id=50a83b3c&scoped=true&"
import script from "./DataScanStandmansFromTime.vue?vue&type=script&lang=ts&"
export * from "./DataScanStandmansFromTime.vue?vue&type=script&lang=ts&"
import style0 from "./DataScanStandmansFromTime.vue?vue&type=style&index=0&id=50a83b3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a83b3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VSimpleTable})
